
<div :id="content.idHTML" class="TODO:" :class="jel_getClassObject(content)">
  <EditableArea
    v-if="mixinEnvironnement_inEditor"
    :content="content.catfish"
    :parentTemplateId="metadata['mgnl:template']"
  />
  <Catfish v-else-if="contentCatfish" :content="contentCatfish"></Catfish>
</div>
